import React, { Component } from 'react';


class Ordersummary extends Component {    

    add_promo_code = (e) => {        
        e.preventDefault();  
        const elementError = document.getElementById('undefined_errors');           
        const result = this.props.add_promo_code();        
        // console.log(`promo code result`, this.props.promo_code_error);
    }

    render(){
        return(
            <React.Fragment>
                <div>
                    <div style={{paddingBottom: '0' }}></div>
                    <div style={{ transform: `translateZ(${0}px)` }}>
                        <div className="checkout__column--right basket-summary">
                            <h2 className="basket-summary__header">{this.props.userlang ==='fr'? 'Résumé de la commande': 'Order Summary'}</h2>
                            <div>
                                <div className="basket-summary__prices">
                                    <div className="basket-summary-line">
                                        <div className="basket-summary-line__title">{this.props.userlang ==='fr'? 'Sous-total': 'Subtotal'}</div>
                                        <div className="basket-summary-line__data">${this.props.basket.total_excl_tax_excl_discounts}</div>
                                    </div>
                                    {
                                                    parseFloat(this.props.basket.total_excl_tax_excl_discounts - parseFloat(this.props.basket.total_excl_tax)) > 0?
                                    <div className="basket-summary-line">
                                        <div className="basket-savings">
                                            <div className="basket-savings__header">
                                                <div className="basket-savings__title">{this.props.userlang ==='fr'? 'Vos économies': 'Your Savings'}<span
                                                        className="accordion"><svg className="basket-savings__title-icon">
                                                            <use href="#icon-question-mark-circle"></use>
                                                            <title>Tempur Icon</title>
                                                        </svg></span></div>
                                                <div className="basket-savings__info accordion-target">
                                                    <p>Promotional codes apply towards retail value only.</p>
                                                    <p>To maximize your savings, site wide offers will automatically
                                                        apply to any remaining balance.</p>
                                                </div>
                                            </div>

                                            {this.props.basket.offer_discounts.map( (line, index) => (
                                            <React.Fragment>
                                            <div className="basket-savings__details">
                                                
                                                <div className="basket-savings__detail">
                                                    <div
                                                        className="basket-savings__title basket-savings__detail-title">
                                                        <span id="offner-name">{line.name}</span></div>
                                                    <div
                                                        className="basket-savings__total basket-savings__detail-total">
                                                        -${line.amount}</div>
                                                </div>
                                            </div>
                                            </React.Fragment>
                                            ))
                                            }

                                            {this.props.basket.voucher_discounts.map( (line, index) => ( 
                                            <React.Fragment>
                                            <div className="basket-savings__details">
                                                
                                                <div className="basket-savings__detail">
                                                    <div
                                                        className="basket-savings__title basket-savings__detail-title">
                                                        <span id="voucher-name">{line.name}</span></div>
                                                    <div
                                                        className="basket-savings__total basket-savings__detail-total">
                                                        -${line.amount}</div>
                                                </div>
                                            </div>
                                            </React.Fragment>
                                            ))
                                            }
                                        </div>
                                    </div>
                                    : ''
                                    }
                                    <div className="basket-summary-line">
                                        <div className="basket-summary-line__title">{this.props.userlang ==='fr'? 'Expédition': 'Shipping'}</div>
                                        <div className="basket-summary-line__data">{this.props.userlang ==='fr'? 'FREE': 'FREE'}</div>
                                    </div>
                                    <div className="basket-summary-line">
                                        <div className="basket-summary-line__title">{this.props.userlang ==='fr'? 'Taxe sur les ventes': 'Sales Tax'}</div>
                                        <div className="basket-summary-line__data">{this.props.order_total_tax === ''? '-': (this.props.order_total_tax).toFixed(2)}</div>
                                    </div>
                                    <div className="basket-summary-line">
                                        <div className="basket-summary-line__title basket-summary-line__title--total">Total
                                        </div>
                                        <div className="basket-summary-line__data">${this.props.order_total_incl_tax === '' ? this.props.basket.total_excl_tax : (this.props.order_total_incl_tax).toFixed(2) }</div>
                                    </div>
                                </div>
                            </div>
                            <div className="basket-summary__promocode">
                                <form className="form">
                                    <div className="basket-summary__promocode-form">
                                        <div className="form__field form__field--has-errors">
                                            <ul id="undefined_errors" className="form__error-list">
                                            {
                                        
                                                this.props.promo_code_error.map( (line, index) => (line))
                                            
                                            } 
                                            </ul>
                                        </div>
                                        <div className="form__field"></div>
                                        <div className="form__field form__field--required form__field--text"><label
                                                className="form__label form__label--outside" htmlFor="checkout-promo-code">{this.props.userlang ==='fr'? 'Ajoutez un code promotionnel': 'Enter a Promo Code'}</label><input id="checkout-promo-code" placeholder=""
                                                required="" type="text" /></div>
                                        <div className="form__field form__field--submit"><input type="submit"
                                                className="button button--inverse button--full-width basket-summary__promocode-submit"
                                                value="Apply" onClick={this.add_promo_code} /></div>
                                    </div>
                                </form>
                            </div>
                            <div>
                                <div className="basket-summary__help">
                                    <h3>{this.props.userlang ==='fr'? 'Des questions': 'Questions?'}</h3>
                                    <p>{this.props.userlang ==='fr'? 'Appelez le': 'Call'} <a href="tel:+1-800-268-4414">(800) 268-4414</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

}

export default Ordersummary;